import { useRouter } from 'next/router'

export const useRouterName = (): string => {
  const router = useRouter()
  return router.pathname.split('/user').reduce((routeName, current) => {
    routeName = `${routeName}${current}`
    return routeName
  }, '')
}
